export default __webpack_public_path__ + "static/media/img12.90acad6a.png";